<script setup lang="ts"></script>

<template>
  <icon name="lucide:external-link" />
</template>

<style scoped></style>
